export const version = { deployed_version: 'v0.12.0', deployed_commit_sha: '3d3626a0ba4a6a4bb7ff15bac0c56fc2b8363fc5' };
